import React from 'react';
import { motion } from 'framer-motion';
import Section from '../../components/ui/Section';

const SocialProof = () => (
  <Section className="bg-darker border-t border-white/5 relative overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.05)_0%,transparent_60%)]" />

    <div className="max-w-6xl mx-auto relative z-10">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <h2 className="text-3xl md:text-5xl font-serif text-cream mb-4">
          Der ROI der{' '}
          <span className="italic text-gold">Seele.</span>
        </h2>
        <p className="text-cream/60 uppercase tracking-widest text-sm">
          Jenseits von Umsatz. Wahre Freiheit.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="glass-panel p-10 md:p-14 relative group hover:border-gold/30 transition-colors duration-500"
        >
          <div className="absolute top-0 right-0 p-8 text-gold/20 group-hover:text-gold/40 transition-colors font-serif text-8xl leading-none">
            "
          </div>
          <p className="relative z-10 text-xl font-light text-cream/90 italic leading-relaxed mb-8">
            „Bevor ich mit Jennifer gearbeitet habe, erwirtschaftete ich siebenstellige
            Zahlen – war aber völlig ausgelaugt. Ich dachte, Skalierung bedeutet, mein
            Privatleben zu opfern. Innerhalb von 4 Monaten im Business Code habe ich
            meine Angebote restrukturiert, meine Preise ohne schlechtes Gewissen
            verdoppelt und arbeite jetzt 3 Tage pro Woche. Der finanzielle ROI war
            enorm – aber der wahre Gewinn ist, dass ich mich endlich wieder lebendig
            fühle."
          </p>
          <div className="border-t border-white/10 pt-6">
            <p className="text-cream font-bold tracking-wider uppercase text-sm">Viktoria S.</p>
            <p className="text-gold text-xs uppercase tracking-widest mt-1">
              CEO & Agentur-Gründerin
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="glass-panel p-10 md:p-14 relative group hover:border-gold/30 transition-colors duration-500"
        >
          <div className="absolute top-0 right-0 p-8 text-gold/20 group-hover:text-gold/40 transition-colors font-serif text-8xl leading-none">
            "
          </div>
          <p className="relative z-10 text-xl font-light text-cream/90 italic leading-relaxed mb-8">
            „Ich hatte Angst vor Sichtbarkeit. Ich hatte die Vision, aber mich hinter
            dem Bildschirm zu verstecken fühlte sich sicherer an. Dieser Container hat
            meine gesamte energetische Signatur verändert. In dem Moment, als ich in
            meine unentschuldigte Queen-Energie getreten bin, begannen meine
            Seelenklientinnen, mich zu finden. Ich habe nicht nur ein Business aufgebaut –
            ich habe meine Kraft zurückerobert."
          </p>
          <div className="border-t border-white/10 pt-6">
            <p className="text-cream font-bold tracking-wider uppercase text-sm">Sophie M.</p>
            <p className="text-gold text-xs uppercase tracking-widest mt-1">
              Visionäre Mentorin
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  </Section>
);

export default SocialProof;